
import React from 'react'
import './CountGraph.css'
import { EntSummaryData } from '../../../../models/summarydataModels/summaryModels'

interface CountGraphProps {
	data: EntSummaryData | undefined | {}
	isLoading: boolean
}

const isEntSummaryData = (data: any): data is EntSummaryData => {
	return data
}

interface ProgressCircleProps {
	percentage: number
}

const ProgressCircle: React.FC<ProgressCircleProps> = ({ percentage }) => {
	const radius = 48
	const circumference = 2 * Math.PI * radius
	const strokeDasharray = circumference
	const strokeDashoffset = circumference - (percentage / 100) * circumference

	return (
		<div className='progress-circle'>
			<svg>
				<circle className='progress-track' cx='60' cy='60' r={radius} />
				<circle
					className='progress-fill'
					cx='60'
					cy='60'
					r={radius}
					style={{
						strokeDasharray,
						strokeDashoffset,
					}}
				/>
			</svg>
			<div className='progress-text'>{percentage}%</div>
		</div>
	)
}

export const CountGraphAnimal = ({ data, isLoading }: CountGraphProps) => {
	if (isLoading) {
		return (
			<div className='loading-container'>
				<div className='loading-spinner'></div>
			</div>
		)
	}

	if (!isEntSummaryData(data)) {
		console.error('Invalid data format:', data)
		return <div className='no-data-container'>Нет данных для отображения</div>
	}

	const formatNumber = (num: number) => {
		return new Intl.NumberFormat('ru-RU').format(num)
	}

	// const formatGrowthText = (current: number, total: number) => {
	//   const percentage = ((current / total) * 100).toFixed(1);
	//   return `Рост: ${percentage}% в сравнении с прошлым месяцем`;
	// };

	return (
		<div className='count-graph-container'>
			{/* Карточка фермеров */}
			<div className='count-card'>
				<div className='count-card-header'>
					<h3 className='count-title'>Количество фермеров</h3>
				</div>

				<div className='progress-container'>
					<ProgressCircle percentage={data.farmerCount.percent} />

					<div className='count-details'>
						<div className='count-number'>
							{/* {formatNumber(data.farmerCount.value)}
						<span className='count-unit'>Человек</span> */}
							<span className='count-unit'>Всего:</span> 
							{formatNumber(data.farmerCount.value)} человек
						</div>

						<div className='count-growth'>
							{/* <svg className="growth-arrow" viewBox="0 0 16 16">
							<path d="M8 3.5l4.5 4.5H9v5H7v-5H3.5L8 3.5z"/>
						</svg> */}
						</div>
					</div>
				</div>
			</div>

			{/* Карточка задач */}
			<div className='count-card'>
				<div className='count-card-header'>
					<h3 className='count-title'>Количество задач</h3>
				</div>

				<div className='progress-container'>
					<ProgressCircle percentage={data.cropProductionWorkCount.percent} />

					<div className='count-details'>
						<div className='count-number'>
							<span className='count-unit'>Всего:</span>
							{formatNumber(data.cropProductionWorkCount.value)}
						</div>

						<div className='count-growth'>
							{/* <svg className="growth-arrow" viewBox="0 0 16 16">
							<path d="M8 3.5l4.5 4.5H9v5H7v-5H3.5L8 3.5z"/>
						</svg> */}
							<div className='count-task-number'>
								<p className='count-subunit'>
									<span className='status-circle done' />
									Выполнено - {formatNumber(data.cropProductionWorkCount.countCompleted)}
								</p>
								<p className='count-subunit'>
									<span className='status-circle not-required' />
									Не требуется - {formatNumber(data.cropProductionWorkCount.countNotRequired || 0)}
								</p>
								<p className='count-subunit'>
									<span className='status-circle not-done' />
									Не выполнено - {formatNumber(data.cropProductionWorkCount.countNotCompleted)}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
